export default "__VITE_ASSET__Cn0j5CGk__"